/** @format */

import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ProductDetailsTranslator {
	toProductDetailsItem(product: any) {
		return {
			partNumber: product.style.partNumber,
			catentryId: product.style.catentryid,
			parentCatentryId: product.style.parentCatentryId,
			buyable: product.style.buyable,
			isaFlag: product.style.isaFlag,
			bopisFlag: product.style.bopisFlag,
			boplFlag: product.style.boplFlag,
			preSale: product.style.preSale,
			clearance: product.style.clearance,
			prices: product.style.prices,
			name: product.style.name,
			longDescription: product.style.longDescription,
			auxDescription: product.style.auxDescription,
			pdpSeoUrl: product.style.pdpSeoUrl,
			definingAttributes: product.style.definingAttributes,
			descriptiveAttributes: product.style.descriptiveAttributes,
			badge: product.style.badge,
			ratingCount: product.style.ratingCount,
			shippingRestricted: product.style.shippingRestricted,
			akamaiRedirect: product.style.akamaiRedirect,
			isPayPalEligible: product.style.isPayPalEligible,
			isPersonalizable: product.style.isPersonalizable,
			isPersonalizedText: product.style.isPersonalizedText,
			personalizedTextCase: product.style.personalizedTextCase,
			personalizedCharLimit: product.style.personalizedCharLimit,
			isEcodePresale: product.style.isEcodePresale,
			sizeAndFit: product.style.sizeAndFit,
			webActiveDate: product.style.webActiveDate,
			isEMComingSoon: product.style.isEMComingSoon,
			quickViewEnabled: product.style.quickViewEnabled,
			primaryCategory: product.style.primaryCategory,
			productType: product.style.productType,
			seo: product.style.seo,
			redirect: product.style.redirect,
			techSpecs: product.style.techSpecs,
			isBuyable: product.style.isBuyable
		};
	}

	toPricingTranslator(product) {
		// insure product details is not empty before translating
		if (
			product.productAttributes &&
			Object.keys(product.productAttributes).length &&
			product.productAttributes.prices.minOfferPrice
		) {
			return {
				...product,
				productAttributes: {
					...product.productAttributes,
					prices: {
						minofferprice:
							product.productAttributes.prices.minOfferPrice.toLocaleString('en', {
								minimumFractionDigits: 2
							}),
						maxofferprice:
							product.productAttributes.prices.maxOfferPrice.toLocaleString('en', {
								minimumFractionDigits: 2
							})
					}
				}
			};
		} else if (
			product.productAttributes &&
			Object.keys(product.productAttributes).length &&
			product.productAttributes.prices.listPrice
		) {
			return {
				...product,
				productAttributes: {
					...product.productAttributes,
					prices: {
						...product.productAttributes.prices,
						offerPrice: product.productAttributes.prices.offerPrice.toLocaleString(
							'en',
							{ minimumFractionDigits: 2 }
						),
						listPrice: product.productAttributes.prices.listPrice.toLocaleString('en', {
							minimumFractionDigits: 2
						})
					}
				}
			};
		}

		return product;
	}
}
